import React, { useEffect, useRef } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

const numIcon = (n) => L.divIcon({
  className: "",
  html: `<div style="width:26px;height:26px;border-radius:50%;background:#1b5e3f;border:2px solid #d4a531;color:#fff;font-weight:700;font-size:12px;display:flex;align-items:center;justify-content:center;box-shadow:0 1px 4px rgba(0,0,0,.4)">${n}</div>`,
  iconSize: [26, 26], iconAnchor: [13, 13],
});

export default function RunRouteMap({ orders }) {
  const ref = useRef(null);
  const mapRef = useRef(null);
  const stops = (orders || [])
    .map((o) => {
      const a = o.dropoff?.lat != null ? o.dropoff : o.pickup;
      return a?.lat != null ? { o, lat: a.lat, lng: a.lng } : null;
    })
    .filter(Boolean);

  useEffect(() => {
    if (!ref.current || stops.length === 0) return;
    if (mapRef.current) { mapRef.current.remove(); mapRef.current = null; }
    const map = L.map(ref.current, { scrollWheelZoom: false });
    mapRef.current = map;
    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
    }).addTo(map);
    const latlngs = stops.map((s) => [s.lat, s.lng]);
    if (latlngs.length > 1) L.polyline(latlngs, { color: "#1b4332", weight: 3, opacity: 0.85 }).addTo(map);
    stops.forEach((s, i) => {
      L.marker([s.lat, s.lng], { icon: numIcon(i + 1) }).addTo(map)
        .bindPopup(`<b>Stop ${i + 1} — ${s.o.tracking_number}</b><br/>${[s.o.dropoff?.line1, s.o.dropoff?.city].filter(Boolean).join(", ")}<br/><span style="color:#6b7280">${s.o.customer_name || ""}</span>`);
    });
    if (latlngs.length === 1) map.setView(latlngs[0], 13);
    else map.fitBounds(L.latLngBounds(latlngs), { padding: [30, 30] });
    return () => { if (mapRef.current) { mapRef.current.remove(); mapRef.current = null; } };
  }, [JSON.stringify(stops.map((s) => [s.o.id, s.lat, s.lng]))]); // eslint-disable-line react-hooks/exhaustive-deps

  if (stops.length === 0) return <p className="py-10 text-center text-sm text-muted-foreground" data-testid="run-map-empty">No mapped stops in this run yet.</p>;
  return <div ref={ref} data-testid="run-route-map" className="h-[420px] w-full overflow-hidden rounded-lg border border-border" />;
}
